import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Attendance from "./tabs/Attendance";
import Status from "./tabs/PublicStatus";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: theme.palette.background.paper,
    background: "linear-gradient(135deg, #f9e7b3 0%, #f4d03f 100%)",
  },
  appBar: {
    background: "#2c3e50",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  tabs: {
    minHeight: "48px",
  },
  tab: {
    minWidth: "120px",
    textTransform: "none",
    fontWeight: 600,
    color: "#2e4f46",
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
      color: "#2e4f46",
    },
    "&.Mui-selected": {
      color: "#2e4f46",
      opacity: 1,
    },
  },
  indicator: {
    backgroundColor: "#f1c40f",
    height: 3,
  },

}));

export default function ScrollableTabsButtonAuto(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  // useEffect(() => {
  //   // setM(props.metadata);
  //   console.log('tabs##', props.attendance)
  // }, [props]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ root: classes.tabs, indicator: classes.indicator }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab
            classes={{ root: classes.tab }}
            label="Status"
            {...a11yProps(1)}
          />
          <Tab
            classes={{ root: classes.tab }}
            label="Attendance"
            {...a11yProps(0)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Status />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Attendance />
      </TabPanel>
    </div>
  );
}
